import * as helpers from '../helpers';

export default function likeButton() {
    const like = document.querySelector('.js-like');
    const currentLink = `${window.location.origin}${window.location.pathname}`;
    let storedData = [];

    const getStorage = () => {
        const localStorageData = localStorage.getItem(`${window.location.hostname}`);

        if (localStorageData) {
            storedData = [...JSON.parse(localStorageData)];
        }
    };

    getStorage();

    storedData.forEach((link) => {
        if (currentLink === link) {
            helpers.addClass(like, '-is-active');
        }
    });

    const toggleBtnTitle = (targetBtn) => {
        const removeTitle = targetBtn.getAttribute('data-title-remove');
        const addTitle = targetBtn.getAttribute('data-title-add');

        if (helpers.hasClass(targetBtn, '-is-active')) {
            if (targetBtn.getAttribute('title')) {
                targetBtn.setAttribute('title', removeTitle);
            }

            targetBtn.innerText = removeTitle;
            targetBtn.setAttribute('title', removeTitle);
        } else {
            if (targetBtn.getAttribute('title')) {
                targetBtn.setAttribute('title', addTitle);
            }

            targetBtn.innerText = addTitle;
            targetBtn.setAttribute('title', addTitle);
        }
    };

    if (like) {
        toggleBtnTitle(like);

        like.addEventListener('click', (e) => {
            e.preventDefault();

            if (!helpers.hasClass(like, '-is-active')) {
                helpers.addClass(like, '-is-active');
                getStorage();
                storedData.push(currentLink);
            } else {
                helpers.removeClass(like, '-is-active');
                getStorage();
                const newArray = [];
                storedData.forEach((link) => {
                    if (currentLink !== link) {
                        newArray.push(link);
                    }
                });

                storedData = newArray;
            }

            toggleBtnTitle(like);

            const serialObj = JSON.stringify(storedData);
            localStorage.setItem(`${window.location.hostname}`, serialObj);
        });
    }
}
